module.exports = __webpack_public_path__ + "img/page-08.b219962b.jpg";